import { render, staticRenderFns } from "./group-manage.vue?vue&type=template&id=7a01d246"
import script from "./group-manage.vue?vue&type=script&lang=js"
export * from "./group-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports